<!-- 公用弹窗 -->
<template>
  <div class="popup-normal">
    <div class="normal-box">
      <div class="bg">
        <div class="zs">打开OK赚助手，请“允许粘贴”<br>才能激活助手</div>
      </div>
      <div class="zt">
        <div class="title">“{{title}}”想从“Safari 浏览器"粘贴</div>
      </div>
      <div class="btn">{{name}}（{{time}}s）</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: () => ''
    },
    title: {
      type: String,
      default: () => ''
    },
    url: {
      type: String,
      default: () => ''
    },
  },
  data() {
    return {
      time:3,
      timeout:null
    };
  },
  created() {
    this.timeout = setInterval(() => {
      this.time--;
      if(this.time < 1){    
        clearTimeout(this.timeout); 
        this.$emit('close', false);
        window.location.href = this.url;
      }
    }, 1000);
  },
  mounted() {},
  methods: {
   
  }
};
</script>
<style lang="less" scoped="scoped">
.popup-normal {
  height:100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0,0,0,0.5);
  .normal-box {
    width: 540px;  
    background: #fff;
    height: 600px;
    border-radius: 20px;
    overflow:hidden;
    .bg{
      width: 544px; 
      height: 286px;
      margin-left: -2px;
      margin-top: -4px;
      background: url('../assets/image/install/popup_bg.png') top center no-repeat;
      background-size: cover;
      .zs{
        font-size: 32px;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
        padding-top: 48px;
      }
    }   
    .zt{
      width: 460px;
      height: 256px;
      background: url('../assets/image/install/popup_copy.png') center no-repeat;
      background-size: 100%;
      margin-top: -110px;
      margin-left: 40px;
      .title{
        font-size: 32px;
        font-weight: bold;
        color: #333333;
        padding-top: 24px;
        width: 372px;
        margin: 0 auto;
        text-align: center;
      }
    }
    .btn{
      width: 480px;
      height: 88px;
      background: #EEEEEE;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 30px;
      margin-top: 36px;
      font-size: 28px;
      color: #666666;
    }
  }
}
</style>
